import { createContext, type MutableRefObject } from 'react';
import { type Swiper as SwiperInstance } from 'swiper';

const StepsContext = createContext(
  {} as {
    swiper: MutableRefObject<SwiperInstance | null>;
  },
);

export { StepsContext };
